/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentForChat
 */
export interface DocumentForChat {
    /**
     * 
     * @type {string}
     * @memberof DocumentForChat
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentForChat
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentForChat
     */
    materialType: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentForChat
     */
    file: string;
}

/**
 * Check if a given object implements the DocumentForChat interface.
 */
export function instanceOfDocumentForChat(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "materialType" in value;
    isInstance = isInstance && "file" in value;

    return isInstance;
}

export function DocumentForChatFromJSON(json: any): DocumentForChat {
    return DocumentForChatFromJSONTyped(json, false);
}

export function DocumentForChatFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentForChat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileName': json['fileName'],
        'materialType': json['materialType'],
        'file': json['file'],
    };
}

export function DocumentForChatToJSON(value?: DocumentForChat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fileName': value.fileName,
        'materialType': value.materialType,
        'file': value.file,
    };
}

